export const tranformToFormData = (data: Record<string, any>) => {
  const newFormData = new FormData();

  Object.keys(data).map((key) => {
    newFormData.append(key, data[key]);
  });
  return newFormData;
};
